<template>
  <div class="m-card-wrapper">
    <router-link :to="route" v-if="route">
      <div class="m-card" :class="{ renew: renew, closed: state === 'closed' }">
        <div class="m-card__body">
          <div class="m-card__body-head">
            <h2>{{ title }}</h2>
          </div>
          <div class="m-card__notification" v-if="renew">
            {{ $t('components.fairListing.fair.renew') }}
          </div>
          <div class="m-card__body-content" v-if="state !== 'closed'">
            <span>{{ displaytext }}<br /></span>
            <span v-if="!renew">{{ location }}<br /></span>
            <span v-if="!renew">{{ placeNum }}<br /></span>
            <span v-if="!renew && area"
              >{{ $t('components.fairListing.fair.area') }}: {{ area }} m<sup
                >2</sup
              ><br
            /></span>
            <span v-if="renew"
              >{{ $t('components.fairListing.fair.renewTitle') }}<br
            /></span>
            <span v-if="renew">{{ source }}<br /></span>
            <span v-if="renew">{{ renewInfo }}</span>
          </div>
          <div class="m-card__body-footer">
            <div>
              <img
                v-if="isExhibitor"
                src="../assets/images/icons/aussteller_white.svg"
                alt=""
              />
              <img
                v-if="!isExhibitor"
                src="../assets/images/icons/mitaussteller_white.svg"
                alt=""
              />
              {{
                $t(
                  'fair.header.standType.' +
                    (isExhibitor
                      ? 'AUSSTELLER'
                      : isDistributor
                      ? 'VERTRAGSHAENDLER'
                      : 'MITAUSSTELLER')
                )
              }}
            </div>
            <img src="../assets/images/icons/chevron_bold_right.svg" alt="" />
          </div>
        </div>
      </div>
    </router-link>

    <div
      class="m-card"
      :class="{ renew: renew, closed: state === 'closed' }"
      v-if="!route"
    >
      <div class="m-card__body">
        <div class="m-card__body-head">
          <h2>{{ title }}</h2>
        </div>
        <div class="m-card__body-content" v-if="state !== 'closed'">
          <span v-if="!renew">{{ location }}<br /></span>
          <span v-if="!renew">{{ placeNum }}<br /></span>
          <span v-if="!renew && area"
            >{{ $t('components.fairListing.fair.area') }}: {{ area }} m<sup
              >2</sup
            ></span
          >
          <span v-if="renew"
            >{{ $t('components.fairListing.fair.renewTitle') }}<br
          /></span>
          <span v-if="renew">{{ source }}<br /></span>
          <span v-if="renew">{{ renewInfo }}</span>
        </div>
        <div class="m-card__body-footer">
          <img src="../assets/images/icons/aussteller_white.svg" alt="" />
          <img src="../assets/images/icons/chevron_bold_right.svg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardFair',
  props: {
    route: {
      type: Object,
      default: () => ({}),
      required: false
    },
    title: {
      type: String,
      default: '',
      required: true
    },
    code: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: ''
    },
    placeNum: {
      type: String,
      default: ''
    },
    area: {
      type: Number,
      default: null
    },
    notifications: {
      type: Array
    },
    registered: {
      type: Boolean,
      default: false
    },
    state: {
      type: String
    },
    source: {
      type: String
    },
    renew: {
      type: Boolean
    },
    renewInfo: {
      type: String
    },
    isExhibitor: {
      type: Boolean
    },
    isDistributor: {
      type: Boolean
    },
    displaytext: {
      type: String
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
$color-main: $brand-turquoise;
$color-renew: #4187ba;
$color-closed: rgba(255, 255, 255, 0.3);

@mixin setBgColorAndHover($color) {
  background-color: $color;

  &:hover {
    background-color: darken($color, 10%);
    cursor: pointer;
  }
}

.m-card-wrapper {
  a {
    text-decoration: none;
  }
}

.m-card {
  @include setBgColorAndHover($brand-primary);
  width: 294px;
  height: 260px;
  border-radius: 20px;
  color: #fff;
  transition: all .2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  @media (max-width: 770px) {
    width: 100%;
  }

  &.renew {
    @include setBgColorAndHover($brand-secondary);
  }

  &__notification {
    position: absolute;
    top: -20px;
    right: 10px;
    font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
    font-size: $card-notification-font-size;
    text-transform: uppercase;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 0.6px;
    color: #ffffff;
    margin-bottom: 0;
    background-color: $brand-primary;
    padding: 9px 16px;
    border-radius: 21px;
  }

  &__body {
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    position: relative;

    h2 {
      font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: 0.6px;
      color: #ffffff;
      margin-bottom: 0;
      font-size: 1.6rem;
    }

    &-content {
      font-size: $card-text-font-size;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: 0.6px;
      flex-grow: 1;
    }

    &-footer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }

  &.closed {
    height: 170px;
    @include setBgColorAndHover($color-closed);
    .m-card__body {
      &-footer {
        > img:first-child {
          opacity: 0;
        }
      }
    }
  }
}
</style>
